import { Outlet } from 'react-router-dom'

export function RootLayout() {
  return (
    <div className="flex flex-1">
      <Outlet />
    </div>
  )
}
